import { useMemo } from "react";
import { WalletType } from "../../enums";

export const usePaymentMethodImage = (methodId: WalletType) => {
  return useMemo(() => {
    switch (methodId) {
      case WalletType.BankTransfer:
        return "/assets/images/bank-transfer.png";
      case WalletType.Paypal:
        return "/assets/images/paypal.png";
      case WalletType.Crypto:
      case WalletType.FlutterwaveKenya:
      case WalletType.Paystack:
      case WalletType.Kora:
        return "/assets/images/card-payment.png";
      default:
        return "/assets/images/card-payment.png";
    }
  }, []);
};
